import * as actions from "./actions";

export const onAddNewWhiteboardClick = (payload) => ({
  type: actions.ON_ADD_NEW_WHITEBOARD_CLICK,
  payload: { ...payload }
});

export const onRemoveWhiteboardClick = (payload) => ({
  type: actions.ON_REMOVE_WHITEBOARD_CLICK,
  payload: { ...payload }
});



// WEBPACK FOOTER //
// ./src/store/analytics/chart-footer/action-creators.js